import MultiplayerChat from "./MultiplayerChat";

export default MultiplayerChat;
